import React, { useEffect } from "react"
import { VolumeToggle } from "./App"

import "./Splash.sass"

function IntructionsIntroSI() {
	return (
		<>
			<p>&gt; Priporočamo ogled na računalniku.</p>
			<p>&gt; Vklopite zvočnike.</p>
		</>
	)
}

function IntructionsIntroEN() {
	return (
		<>
			<p>&gt; We recommend viewing the page on your PC.</p>
			<p>&gt; Turn on the speakers.</p>
		</>
	)
}

export function Splash({ onConfirm, isSoundAllowed, setSoundAllowed }) {
	useEffect(() => {
		const listener = (event) => {
			event.preventDefault()
			onConfirm && onConfirm()
		}

		window.addEventListener('keydown', listener)

		return () => {
			window.removeEventListener('keydown', listener)
		}
	}, [onConfirm])

	return (
		<div className="Splash">
			<div className="text-content">
				<h1>
					ByeByeWorld.exe
					<br />
					--------------
				</h1>

				<div className="slovenian">
					{/* <p>Dobrodošli v letu 3020, mnogo let po izumrtju človeštva.</p> */}
					<IntructionsIntroSI />
				</div>

				<div className="english">
					{/* <p>
						Welcome to the year 3020, many years after humankind had gone
						extinct.
					</p> */}
					<IntructionsIntroEN />
				</div>

				<div className="entry">
					<VolumeToggle
						isActive={isSoundAllowed}
						onClick={() => setSoundAllowed(isSoundAllowed ? null : true)}
					/>

					<button onClick={onConfirm}>
						[<span className="slovenian">Vstopite</span>
						<span className="english">/ Enter</span>]
					</button>
				</div>
			</div>
		</div>
	)
}
